import { createAsyncThunk } from '@reduxjs/toolkit';

import AuthService from 'features/auth/authService';

import { ClientWorkspace, RegistrationMetrics, User } from 'types/auth';

export const fetchUserData = createAsyncThunk<User, void>(
  'auth/fetchUserData',
  async (_, { rejectWithValue }) => {
    try {
      const user = await AuthService.getUser();
      return user;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchClientWorkspaceData = createAsyncThunk<ClientWorkspace, void>(
  'auth/fetchClientWorkspaceData',
  async (_, { rejectWithValue }) => {
    try {
      const clientWorkspace = await AuthService.getClientWorkspace();
      return clientWorkspace;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchRegistrationMetrics = createAsyncThunk<
  RegistrationMetrics,
  void
>('auth/fetchRegistrationMetrics', async (_, { rejectWithValue }) => {
  try {
    const registrationMetrics = await AuthService.getRegistrationMetrics();
    return registrationMetrics;
  } catch (error) {
    return rejectWithValue(error);
  }
});
